import { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("mj_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("mj_cart", JSON.stringify(items));
  }, [items]);

  const add = useCallback((product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.id === product.id);
      if (found) return prev.map((i) => i.id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      return [...prev, { id: product.id, name: product.name, price: product.price, slug: product.slug, quantity: qty }];
    });
    setOpen(true);
  }, []);

  const updateQty = useCallback((id, quantity) => {
    if (quantity <= 0) { setItems((p) => p.filter((i) => i.id !== id)); return; }
    setItems((p) => p.map((i) => i.id === id ? { ...i, quantity } : i));
  }, []);

  const remove = useCallback((id) => setItems((p) => p.filter((i) => i.id !== id)), []);
  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, updateQty, remove, clear, count, total, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};
